import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { fontSizes, spacing } from 'syf-component-library/defaultTheme';
import SlideInModalPortal from 'syf-component-library/ui/patterns/SlideInModalPortal/SlideInModalPortal';
import { Inset } from 'syf-component-library/ui/spacing';
export const ModalContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
export const ModalContainer = styled.div `
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media ${query.greaterThanMedium} {
    margin-right: 44px;
    margin-left: 44px;
  }
`;
export const ModalBody = styled.div `
  text-align: center;
`;
export const ModalImage = styled.img `
  margin-top: 18px;
  margin-bottom: 34px;
  max-width: 100%;
  max-height: 100%;
`;
export const PaymentModalWrapper = styled(Inset) `
  flex-grow: 1;
  @media ${query.lessThanMedium} {
    padding-left: ${spacing.base}px;
    padding-right: ${spacing.base}px;
  }
`;
export const MessageBoxInset = styled(Inset) `
  @media ${query.lessThanMedium} {
    padding: ${spacing.xlarge}px ${spacing.base}px 0px ${spacing.base}px;
  }
`;
export const IntroHeadingInset = styled(Inset) `
  @media ${query.lessThanMedium} {
    padding: ${spacing.large}px ${spacing.base}px ${spacing.base}px
      ${spacing.base}px;
  }
`;
export const SlideInModalPortalWrapper = styled(SlideInModalPortal) `
  svg {
    box-sizing: unset;
  }
  ,
  h1 {
    font-size: ${fontSizes.root}px;
  }
`;
export const ScrollTop = styled.span `
  visibility: hidden;
  height: 0;
  width: 0;
`;
